import { render, staticRenderFns } from "./Maintenancefees.vue?vue&type=template&id=54c29846"
import script from "./Maintenancefees.vue?vue&type=script&lang=js"
export * from "./Maintenancefees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports